import { render, staticRenderFns } from "./ClassificationDegreeTable.vue?vue&type=template&id=6efd402b&"
import script from "./ClassificationDegreeTable.vue?vue&type=script&lang=js&"
export * from "./ClassificationDegreeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports